import { useCallback, useEffect, useState } from 'react';
import { EventName, Params, TrackingElementType } from '../types';
import { useAnalyticsContext } from './analytics.provider';
import { mapDataVizForChartType } from './utils';

/**
 * chartName is only used when isCollection is truthy as it will only used on collection page
 */
export const useTrackChartTooltipEvent = (componentSettings: Params, isCollection?: boolean, chartName?: string) => {
  const [trackTooltip, setTrackTooltip] = useState<boolean>(false);
  const [chartTooltipTracked, setChartTooltipTracked] = useState<boolean>(false);
  const { trackPageEvent } = useAnalyticsContext();

  const trackChartEvent = useCallback(() => {
    const collectionProps = isCollection && {
      section: 'Collections',
      subsection: 'Collections Details',
      pageName: 'Collections Details',
    };

    const dataVizValue = componentSettings.dataViz?.[0];
    const chartType = mapDataVizForChartType(dataVizValue);

    trackPageEvent &&
      trackPageEvent(EventName.ChartInteractions, {
        elementType: TrackingElementType.Tooltip,
        elementName: 'Chart hover',
        chartType,
        elementKPI: componentSettings.scKpis,
        ...(isCollection && chartName && { chartName }),
        ...collectionProps,
      });
  }, [chartName, componentSettings, isCollection, trackPageEvent]);

  useEffect(() => {
    if (chartTooltipTracked) {
      return;
    }
    if (trackTooltip) {
      trackChartEvent();
      setChartTooltipTracked(true);
    }
  }, [trackChartEvent, trackTooltip, chartTooltipTracked]);

  useEffect(() => {
    setChartTooltipTracked(false);
    setTrackTooltip(false);
  }, [componentSettings]);

  const trackTooltipEvent = () => {
    setTrackTooltip(true);
  };

  return { trackTooltipEvent };
};
